import http from './http.common';
import { InferGetResult_Request, InferGetResult_Response } from '../types/DictionaryTypes';
class DictionaryService {
    async getResult(sentence: string) {
        const params: InferGetResult_Request = {
            sentence,
            withDictionaries: true,
        };
        return http.post<InferGetResult_Response>(`/infer/getResult`, params);
    }
}
export default new DictionaryService();